import React from 'react'

const Manual_desactivar_productos_clau = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Desactivar productos dentro de Clau.io
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende cómo desactivar productos desde el panel del Dashboard de Clau.io para gestionar la disponibilidad en tu catálogo.
        </p>
        <iframe
          src="https://scribehow.com/embed/Desactivar_productos_dentro_de_Clau_io__052TYdUXQSyMqjOUgv2NDA?as=scrollable"
          className="scribe-iframe-general-129"
          width="100%"
          height="2100"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_desactivar_productos_clau
